import { Injectable, inject } from '@angular/core';

import { ConfigService } from '@app-core/services';
import { PrismicDataResponse } from '@app-model/api';
import * as prismic from '@prismicio/client';
import { Client, Query } from '@prismicio/client';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PrismicService {
  private _configService = inject(ConfigService);
  private _environment = this._configService.environment;

  private _apiEndpoint = 'https://phoenix-ui.cdn.prismic.io/api/v2';
  private _accessToken: string = this._environment.prismicAccessId;
  private readonly _prismicTypeId: string = 'my.davinci.uid';

  private _client: Client = prismic.createClient(this._apiEndpoint, { accessToken: this._accessToken });

  getPrismicData(): Observable<PrismicDataResponse> {
    return from(
      this._client.get({
        filters: [prismic.filter.at(this._prismicTypeId, this._configService.appIdentifier)],
      })
    ).pipe(map((response: Query) => response as unknown as PrismicDataResponse));
  }
}
